import { render, staticRenderFns } from "./communication-tags-tool.vue?vue&type=template&id=461d6f56"
import script from "./communication-tags-tool.vue?vue&type=script&lang=js"
export * from "./communication-tags-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports